<template>
  <el-form
    status-icon
    :model="driver"
    :rules="rules"
    label-position="top"
    ref="ruleForm"
    label-width="120px"
    v-loading="loading"
    class="carpo-form demo-ruleForm gap-y-6"
  >
    <el-form-item
      :label="$t('DRIVING_LICENSE_TYPE')"
      prop="driving_license_types"
      v-loading="licenseLoading"
    >
      <el-select
        :disabled="ruleForm.disabled"
        :placeholder="$t('SELECT_PLACEHOLDER')"
        multiple
        :collapse-tags="!driver.disabled"
        clearable
        filterable
        v-model="driver.driving_license_types"
      >
        <el-option
          v-for="item in certificateList"
          :key="item.id"
          :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('DRIVING_LICENSE_ID')" prop="driving_license_id">
      <el-input
        :disabled="ruleForm.disabled"
        type="text"
        @input="
          driver.driving_license_id = toEnglish(driver.driving_license_id)
        "
        v-model="driver.driving_license_id"
        autocomplete="off"
        class="left-inputs"
      ></el-input>
    </el-form-item>
    <el-form-item
      :label="$t('LICENSE_EXPIRY_DATE')"
      prop="driving_license_expiry_date"
    >
      <date-picker
        :disabled="ruleForm.disabled"
        color="#151515"
        class="el-input__inner"
        v-model="driver.driving_license_expiry_date"
        view="year"
        format="jYYYY-jMM-jDD"
        clearable
        :locale="$i18n.locale"
      />
    </el-form-item>

    <el-form-item :label="$t('SMART_CARD')" prop="smart_card_id">
      <el-input
        :disabled="ruleForm.disabled"
        type="text"
        @input="driver.smart_card_id = toEnglish(driver.smart_card_id)"
        v-model="driver.smart_card_id"
        autocomplete="off"
        class="left-inputs"
      ></el-input>
    </el-form-item>

    <!-- <el-form-item :label="$t('SMART_CARD')" prop="has_smart_card">
      <el-select
        :disabled="ruleForm.disabled"
        filterable
        v-model="driver.has_smart_card"
        :placeholder="$t('SELECT_PLACEHOLDER')"
      >
        <el-option
          v-for="item in addictedList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item> -->

    <FormConfirmation
      :loading="submitLoading"
      v-if="!ruleForm.disabled"
      @resetForm="resetForm('ruleForm')"
      @submitForm="submitForm('ruleForm')"
    />
  </el-form>
</template>

<script>
import { gregorianToJalali } from '@/mixins/gregorianToJalali'
import { jalaliToGregorian } from '@/mixins/jalaliToGregorian'
import FormConfirmation from '@/components/elements/formConfirmation.vue'
import { driverLicensetypes, getPro, addPro, editPro } from '@/api/drivers'

export default {
  props: ['ruleForm', 'loading'],
  mixins: [gregorianToJalali, jalaliToGregorian],
  data() {
    return {
      certificateList: [],
      get_driver: null,
      licenseLoading: true,
      submitLoading: false,
      driver: this.ruleForm,
      addictedList: [
        {
          value: true,
          label: this.$i18n.t('PROVIDED'),
        },
        {
          value: false,
          label: this.$i18n.t('NOT_PROVIDED'),
        },
      ],

      rules: {
        driving_license_type: [
          {
            required: false,
            message: this.$i18n.t('REQUIRED_CHOOSE', {
              type: this.$i18n.t('DRIVING_LICENSE_TYPE'),
            }),
            trigger: 'blur',
          },
        ],
        driving_license_id: [
          {
            required: false,
            message: this.$i18n.t('REQUIRED_CHOOSE', {
              type: this.$i18n.t('DRIVING_LICENSE_ID'),
            }),
            trigger: 'blur',
          },
        ],
        driving_license_expiry_date: [
          {
            required: false,
            message: this.$i18n.t('REQUIRED_CHOOSE', {
              type: this.$i18n.t('LICENSE_EXPIRY_DATE'),
            }),
            trigger: 'blur',
          },
        ],
        has_smart_card: [
          {
            required: false,
            message: this.$i18n.t('REQUIRED_CHOOSE', {
              type: this.$i18n.t('SMART_CARD'),
            }),
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          const actionPayload = {
            driving_license_types: this.driver.driving_license_types,
            driving_license_id: this.driver.driving_license_id,
            driving_license_expiry_date:
              this.driver.driving_license_expiry_date != ''
                ? this.jalaliToGregorian(
                    this.driver.driving_license_expiry_date,
                    this.$i18n.locale
                  )
                : null,
            smart_card_id: this.driver.smart_card_id,
            driver: this.ruleForm.id,
            id: this.ruleForm.id,
          }
          this.submitLoading = true
          var dispatchFunc = this.get_driver == null ? addPro : editPro

          dispatchFunc.api(actionPayload).then((res) => {
            this.submitLoading = false
            if (res) {
              this.get_driver = res
              this.$notify.success({
                title: this.$t('PRO_INFO') + ' ' + this.$t('SUCCESSFULLY_'),
                duration: 5000,
                customClass: 'succ_msg',
              })
            }
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t('PRO_INFO'),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
  },
  mounted() {
    driverLicensetypes.api().then((res) => {
      if (res) {
        this.certificateList = res
        this.licenseLoading = false
      }
    })

    getPro.api(this.ruleForm.id).then((res) => {
      this.loading = false
      if (res) {
        res = {
          ...res,
          driving_license_expiry_date: this.gregorianToJalali(
            res.driving_license_expiry_date
          ),
          driving_license_types: res.driving_license_types.map((i) => i.id),
        }
        this.driver = res
        this.get_driver = res
      }
    })
  },
  components: {
    FormConfirmation,
  },
}
</script>
